import React from 'react';
import styled from 'styled-components';

import { toRem } from '@front/common/src/utils/styles';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import Modal from '@front/web-ui/src/components/modal/modal';

const t = translate('screens.signup.user.email_taken_modal');

const ModalContent = styled.div`
  padding: 0 ${toRem(20)} ${toRem(20)};
  display: flex;
  justify-content: center;
`;

type EmailTakenAlertModalProps = {
  closeModal: () => void;
  openLoginScreen: () => void;
  isOpen: boolean;
};

const EmailTakenAlertModal = ({ closeModal, openLoginScreen, isOpen }: EmailTakenAlertModalProps) => (
  <Modal
    title={t('.title')}
    isOpen={isOpen}
    onClose={closeModal}
    primaryButton={{
      children: t('.button'),
      onPress: openLoginScreen,
    }}
  >
    <ModalContent>
      <Text centered={true}>{t('.text')}</Text>
    </ModalContent>
  </Modal>
);

export default EmailTakenAlertModal;
